
export const pricelistSchema = {
    price_package_id: '{type:"readOnly", rules:"required", storeNamespace: "pricepackages", objectNamespace: "O_pricepackage", itemText: "name"}',
    product_ids: '{type:"selectData", rules:"required", storeNamespace: "services", objectNamespace:"A_product", itemText: "name_full", multiple:"true"}',
    //price_package_id: '{type:"selectData", rules:"required", storeNamespace: "pricepackages", objectNamespace:"A_pricepackage", itemText: "name"}',
    //date_valid_from: '{type:"datePicker"}',
    //date_valid_to: '{type:"datePicker"}'
}